import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from '../..';
import { PaymentRecord, PaymentType } from 'app/services/responseTypes';

export const PaymentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query<
      IPaginatedRepsonse<PaymentRecord>,
      IGetQueryParams<{}>
    >({
      query: (params) => `/payments${buildQueryParams(params)}`,
      transformResponse: (response: IPaginatedRepsonse<any>) => ({
        data: response.data.map((p: any) => ({
          ...p,
          payment_type: detectType(p),
        })),
        pagination: response.pagination,
      }),
    }),
  }),
});

function detectType(p: any): PaymentType {
  if (p.order_items) return 'order';
  if (p.product_meta) return 'service';
  if (p.engagement_letter) return 'project';
  if ('payment_status' in p || 'extension_price' in p) return 'tax_extension';
  return p.type as PaymentType;
}

export const { useLazyGetPaymentsQuery, useGetPaymentsQuery } = PaymentsApi;
